<template>
  <div class="container">
    <content-header :data="[{text: test_name + ' 测试明细', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="name"
            label="用户名"
            width="150"
            fixed
            >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="测试开始时间"
            width="160">
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="测试完成时间"
            width="160">
          </el-table-column>
          <el-table-column
            prop="minute"
            label="用时">
          </el-table-column>
          <el-table-column
            prop="question_count"
            label="总题数">
          </el-table-column>
          <el-table-column
            prop="correct_count"
            label="正确数">
          </el-table-column>
          <el-table-column
            label="是否通过">
            <template slot-scope="scope">
              <span>{{scope.row.passed?'是':'否'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import TestModel from 'models/test'

  export default {
    components: {
    },
    data () {
      return {
        test_id: '',
        test_name: '',
        tableData: [],
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      this.test_id = this.$route.query.id
      console.log(this.test_id)
      if (this.test_id) {
        //
        this.getObjList()
      }
    },
    methods: {
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          test_id: this.test_id
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        console.log(_opts)
        //
        TestModel.getTestResultDetail(_opts).then(res => {
          this.test_name = res.test_name
          this.tableData = res.item_list
          this.total = res.total
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
</style>



// WEBPACK FOOTER //
// src/views/TestResultDetail.vue